import { findContentfulFlagValue } from 'components/PageSections/utils';
import { PricingCardProps } from 'components/PricingCard';
import { RESULTS_ROOT } from 'utils/constants/urls';
import { shouldUrlSkipScreenerModal } from 'utils/helpers/urls/skipModal';

import { StickyMdpCtaProps } from './StickyMdpCta';

const DEFAULT_PRICE = '39';
const DEFAULT_PRICE_FREQUENCY = 'month';
const DEFAULT_URL = `${RESULTS_ROOT}/virtual-care/intake?program=everlywell-plus`;
const DEFAULT_CTA_TEXT = 'Join today ';
const DEFAULT_CTA_STARTING_TEXT = 'From';
const DEFAULT_CTA_TRACKING_TEXT = '$39/month Join today ';
const DEFAULT_CTA_TRACKING_SECTION_HEADER = 'Everlywell+ Sticky CTA';

const DEFAULT_CTA = {
  label: DEFAULT_CTA_TEXT,
  url: DEFAULT_URL,
};

type ParseStickyMdpCtaType = {
  metadata?: Queries.ContentfulMetadata001;
  option?: PricingCardProps;
};

export const parseStickyMdpCta = ({
  metadata,
  option,
}: ParseStickyMdpCtaType): StickyMdpCtaProps => {
  const sectionTitle = metadata?.title;
  const cta = metadata?.ctas?.[0];

  if (!cta) {
    return {
      label: DEFAULT_CTA.label,
      url: option?.url || DEFAULT_CTA.url,
      hideSeparator: false,
      startingText: DEFAULT_CTA_STARTING_TEXT,
      price: {
        value: option?.price?.value || DEFAULT_PRICE,
        frequency: DEFAULT_PRICE_FREQUENCY,
      },
      tracking: {
        sectionHeader: DEFAULT_CTA_TRACKING_SECTION_HEADER,
        ctaText: DEFAULT_CTA_TRACKING_TEXT,
      },
    };
  }

  const ctaParts = cta?.metadata?.context?.ctaParts;
  const ctaTrackingText = `${ctaParts?.startingText} ${ctaParts?.priceText} ${
    ctaParts?.hideSeparator ? ' ' : '/'
  } ${ctaParts?.billFrequencyText}`;

  function setUrl() {
    const skipScreenerModal = findContentfulFlagValue(
      'skipScreenerModal',
      cta?.metadata?.flags,
    );

    if (
      skipScreenerModal ??
      shouldUrlSkipScreenerModal({ url: cta?.url as string | undefined })
    ) {
      return cta?.url || '';
    }

    return option?.url || cta?.url || '';
  }

  return {
    label: cta.label || '',
    url: setUrl(),
    hideSeparator: ctaParts?.hideSeparator || false,
    startingText: ctaParts?.startingText || '',
    price: {
      value: ctaParts?.priceText || '',
      frequency: ctaParts?.billFrequencyText || '',
    },
    tracking: {
      sectionHeader: `${sectionTitle} Sticky CTA`,
      ctaText: ctaTrackingText,
    },
  };
};
